import Vue from 'vue'
import App from './App'
import router from './_router'
import store from './_vuex'
import './_axios'
import { bind } from "./utils/NumberAnim";
// vant
// eslint-disable-next-line import/no-duplicates
import Vant from 'vant'

import 'vant/lib/index.css'
// iconfont
import './iconfont/iconfont.css'
// 日期格式化
import './utils/dateFormatUtil'
// api
import './api'

import './utils/Message'
// 设置title
import VueWechatTitle from 'vue-wechat-title'

import TitleBar from '@/components/TitleBar'
// 高德地图组件 初始化速度太慢，刷新页面会出现问题，改为组件内引用
// import VueAMap from 'vue-amap'
// Vue.use(VueAMap)
//
// VueAMap.initAMapApiLoader({
//   key: '2a9f6185c25f34dd1e2ee159f0e2e810',
//   plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
//   v: '1.4.15',
//   uiVersion: '1.0.11'
// })

/* 修改页面标题 */
// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   next()
// })
Vue.prototype.auth = auth

import api from './api/api'
Vue.prototype.$axios = api

import moment from 'moment'// 日期格式化
Vue.prototype.$moment = moment// 赋值使用

function auth(role) {
  const perms = store.getters.perms
  return perms.indexOf(role) !== -1
}

// import eruda from 'eruda/eruda.js' // 引入工具包
// eruda.init()

import { Icon } from 'element-ui'
import './icons'
import { Col, Row } from 'vant'
import VCharts from 'v-charts'

Vue.use(Icon)
Vue.use(Col)
Vue.use(Row)
bind(Vue)
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(VueWechatTitle)
Vue.component('title-bar', TitleBar)
Vue.use(VCharts)/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js